/**
 * Страница курсорного списка в том виде, в каком её отдаёт API, и ровно то, что нужно
 * экранам: элементы — чтобы отличить пустую страницу от непрочитанной, `nextCursor` —
 * чтобы решить судьбу кнопки «дальше».
 */
type Page = { items: readonly unknown[]; nextCursor: string | null };

/** Часть результата TanStack Query, которую читают `PageFallback` и `CursorPager`. */
export type PageQuery = {
  data?: Page;
  isError: boolean;
  error: unknown;
  isPending: boolean;
  isFetching?: boolean;
};

export type PagerHandle = {
  canGoBack: boolean;
  forward: (next: string) => void;
  back: () => void;
};

/** Есть ли что показывать: страница прочитана и не пуста. */
export function hasItems(query: PageQuery): boolean {
  return query.data !== undefined && query.data.items.length > 0;
}
